import React from 'react';
import styled, { css } from 'styled-components';

import { NewSelectProps } from '../../NewSelect';
import CoreSelect, { SelectElement, arrowWidth } from '../../../_common/CoreSelect/CoreSelect';
import Aura from '../../../_common/Aura/Aura';
import Outline from '../../../_common/Outline/Outline';

const StyledSelect = styled(CoreSelect)`
  height: 40px; /* Prevents changing the cell original size */
  z-index: 1; /* Places it above Aura so content is selectable */

  ${SelectElement} {
    height: 40px; /* Prevents changing the cell original size */

    &,
    &:hover {
      background: none;
      border: none;
      box-shadow: none;
    }

    ${({ align }) =>
      align === 'right' &&
      css`
        /* Reset padding and reserves real estate on the left for arrow icon */
        &,
        &:focus-visible {
          padding: 10px;
          padding-left: ${arrowWidth};
        }
      `}
  }
`;

function TableSelect(props: NewSelectProps) {
  const { className, style, ...otherProps } = props;
  return (
    <>
      <StyledSelect {...otherProps} width="full" />
      <Aura theme={{ disabled: props.disabled }} htmlFor={props.id} />
      <Outline theme={{ invalid: props.invalid, disabled: props.disabled }} inputComponent={StyledSelect} />
    </>
  );
}

TableSelect.defaultProps = {
  width: 'large',
  invalid: false,
  disabled: false,
};

export default TableSelect;
